import React from 'react';

function CenteredContent({ className, background, sectionTitle, children }) {
  return (
    <>
      {background && <div className="open-position-bg" />}
      <div className={`${className || ''} col-xl-4 col-md-4 col-sm-12 mb-sm-0 text-left`}>
        {sectionTitle && <h3 className="content-section-title mb-32">{sectionTitle}</h3>}
      </div>
      <div className={`${className || ''} col-xl-8 col-md-8 col-sm-12`}>
        <div className="centered-content px-0 px-sm-3">
          {children}
        </div>
      </div>
    </>
  );
}

export default CenteredContent;